import type { EditorHandle } from "@shared/ui/Editor/ui";
import { useRef, useState, type RefObject } from "react";
import { editorHasAttachableContent } from "./attachTask";

export function useAttachEditorContent(
  editorRef: RefObject<EditorHandle | null>
) {
  const [hasContent, setHasContent] = useState(false);
  const [isMediaUploading, setIsMediaUploading] = useState(false);
  const ignoreMediaStartRef = useRef(false);

  const resetContentState = () => {
    setHasContent(false);
    setIsMediaUploading(false);
    ignoreMediaStartRef.current = false;
  };

  const syncContent = () => {
    const has = editorHasAttachableContent(editorRef.current);
    if (has) {
      setHasContent(true);
      return;
    }
    if (!ignoreMediaStartRef.current) setHasContent(false);
  };

  const handleImportComplete = () => {
    ignoreMediaStartRef.current = true;
    setIsMediaUploading(false);
    setHasContent(true);
    window.setTimeout(() => {
      ignoreMediaStartRef.current = false;
    }, 800);
  };

  const handleMediaUploadStart = () => {
    if (ignoreMediaStartRef.current) return;
    setIsMediaUploading(true);
  };

  const handleMediaUploadComplete = () => {
    setIsMediaUploading(false);
    syncContent();
  };

  return {
    hasContent,
    setHasContent,
    isMediaUploading,
    resetContentState,
    syncContent,
    handleImportComplete,
    handleMediaUploadStart,
    handleMediaUploadComplete,
  };
}
